import * as React from 'react';

import { Form, Row, Spin } from 'antd';
import { AimOutlined, Input, Space, Tooltip } from 'farmhub-ui-core';
import { useSelector } from 'react-redux';

import { RootState, useAppDispatch, useAppSelector } from 'app';
import { LocationSelectMobile, LocationSelectV1 } from 'components';
import { findLocationValue, resetLocationSearch, selectAppDevice } from 'slice';
import { theme } from 'styled';
import { COLLABORATOR_TEXT, DEVICES } from 'utils';
import {
  getCurrentLocation,
  isVietnamesePhoneNumber,
  validateEmail,
} from 'utils/function';

import { CForm } from './styles';

interface InformationStepProps {
  form: any;
  isValidEmail: boolean;
  hasErrorCode: boolean;
  isValidPhoneNumber: boolean;
  setHasErrorCode: (e: boolean) => void;
  setIsValidEmail: (e: boolean) => void;
  setIsValidPhoneNumber: (e: boolean) => void;
}

const InformationStep = ({
  form,
  isValidEmail,
  hasErrorCode,
  isValidPhoneNumber,
  setIsValidEmail,
  setHasErrorCode,
  setIsValidPhoneNumber,
}: InformationStepProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const appDevice = useAppSelector(selectAppDevice);
  const [isLoadingAddress, setIsLoadingAddress] = React.useState(false);
  const findLocation = useSelector(
    (state: RootState) => state.location.findLocation
  );

  const handleVerifyEmail = e => {
    setIsValidEmail(validateEmail(e.target.value));
  };

  const handleVerifyPhone = e => {
    setIsValidPhoneNumber(isVietnamesePhoneNumber(e.target.value));
  };
  const handleChangeIsLoadingAddress = (e: boolean): void => {
    setIsLoadingAddress(e);
  };

  const handleGetLocationCode = (value: any): void => {
    dispatch(
      findLocationValue({
        districtName: value.districtName,
        provinceName: value.provinceName,
        wardName: value.wardName,
        address: value.address,
        latitude: value.latitude,
        longitude: value.longitude,
      })
    );
  };

  React.useEffect(() => {
    if (findLocation) {
      const bodyUpdate = {
        address: findLocation.address,
        provinceCode: findLocation.provinceCode,
        districtCode: findLocation.districtCode,
        wardCode: findLocation.wardCode,
        latitude: findLocation.latitude,
        longitude: findLocation.longitude,
      };
      form.setFieldsValue(bodyUpdate);
      setIsLoadingAddress(false);
      dispatch(resetLocationSearch());
    }
  }, [dispatch, findLocation, form]);

  return (
    <>
      <CForm
        className="login-form"
        form={form}
        layout="vertical"
        name="add_address_form"
        style={{ width: appDevice.device === DEVICES.DESKTOP ? 420 : '100%' }}
      >
        <Form.Item
          label={`Tên ${COLLABORATOR_TEXT.LOWERCASE}`}
          name="fullName"
          rules={[
            {
              required: true,
              message: 'Bạn chưa nhập tên!',
            },
          ]}
        >
          <Input
            height={theme.input.height.md}
            placeholder={`Tên ${COLLABORATOR_TEXT.LOWERCASE}`}
          />
        </Form.Item>
        <Form.Item
          help={
            isValidEmail ? null : (
              <span style={{ color: 'red' }}>Email không hợp lệ</span>
            )
          }
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              message: 'Bạn chưa nhập email',
            },
          ]}
        >
          <Input
            height={theme.input.height.md}
            placeholder="Email"
            onChange={handleVerifyEmail}
          />
        </Form.Item>
        <Form.Item
          help={
            isValidPhoneNumber ? null : (
              <span style={{ color: 'red' }}>Số điện thoại không hợp lệ!</span>
            )
          }
          label="Số điện thoại"
          name="phoneNumber"
          rules={[
            {
              required: true,
              message: 'Bạn chưa nhập số điện thoại',
            },
          ]}
        >
          <Input
            height={theme.input.height.md}
            placeholder="Số điện thoại"
            onChange={handleVerifyPhone}
          />
        </Form.Item>
        <Row gutter={[0, 0]}>
          {appDevice.device === DEVICES.DESKTOP ? (
            <LocationSelectV1
              required
              districtCodeInit={form.getFieldValue('districtCode')}
              form={form}
              hasErrorCode={hasErrorCode}
              idPopup="normal_login"
              isLoadingAddress={isLoadingAddress}
              marginBottom={0}
              provinceCodeInit={form.getFieldValue('provinceCode')}
              setHasErrorCode={setHasErrorCode}
              showTitle={false}
              wardCodeInit={form.getFieldValue('wardCode')}
            />
          ) : (
            <>
              <LocationSelectMobile
                districtCodeInit={form.getFieldValue('districtCode')}
                form={form}
                hasErrorCode={hasErrorCode}
                idPopup="normal_login"
                isLoadingAddress={isLoadingAddress}
                isNotShowLabel={false}
                marginBottom={0}
                provinceCodeInit={form.getFieldValue('provinceCode')}
                setHasErrorCode={setHasErrorCode}
                wardCodeInit={form.getFieldValue('wardCode')}
              />
              <Space height={18} />
            </>
          )}
        </Row>
        <Form.Item
          label="Địa chỉ"
          name="address"
          rules={[
            {
              required: true,
              message: 'Bạn chưa nhập địa chỉ',
            },
          ]}
        >
          <Input
            height={theme.input.height.md}
            placeholder="Địa chỉ"
            suffix={
              <Tooltip title="Lấy vị trí hiện tại">
                {!isLoadingAddress ? (
                  <AimOutlined
                    style={{
                      color: theme.colors.primary.main,
                      fontSize: '20px',
                    }}
                    onClick={() =>
                      getCurrentLocation(
                        handleChangeIsLoadingAddress,
                        handleGetLocationCode
                      )
                    }
                  />
                ) : (
                  <Spin
                    style={{
                      color: theme.colors.primary.main,
                      fontSize: '20px',
                    }}
                  />
                )}
              </Tooltip>
            }
          />
        </Form.Item>
      </CForm>
    </>
  );
};

export default InformationStep;
